import React from 'react';
import PropTypes from 'prop-types';
import PictionJS from 'piction-js';
import { Map } from 'immutable';
import _ from 'lodash';
import { injectIntl } from 'react-intl';
import { formatBytes, formatDuration } from '../../utils/dataUtils';
import MetadataViewItem from '../MetadataView/MetadataViewItem';
import appConfig from '../../appConfig';

function UMODataFields({
  umo,
  session,
  dispatch,
  intl,
}) {
  // origData is the general dataset that returns with each umo
  // values like height/width/size are usually populated only for photos
  let origData = umo.data.o && umo.data.o.find(item => item.$ && item.$.pn === 'Original Asset');
  origData = origData ? origData.$ : false;
  let date = umo.data.dc[0] && new Date(umo.data.dc[0]).toDateString();
  date = date ? date.substr(date.indexOf(' ') + 1) : '';
  // return only the specific type of the image
  const type = origData ? _.split(origData.mt, '/')[1].toUpperCase() : umo.type;
  let size;
  let height;
  let width;
  let duration;
  let durationField;
  switch (umo.type) {
    case 'PHOTO':
      if (origData) {
        size = origData.sz ? formatBytes(origData.sz, 2) : '';
        height = origData.h;
        width = origData.w;
      }
      break;
    case 'VIDEO':
      height = umo.metadataList.getMetadata('VIDEO.HEIGHT') ? umo.metadataList.getMetadata('VIDEO.HEIGHT').value : '';
      width = umo.metadataList.getMetadata('VIDEO.WIDTH') ? umo.metadataList.getMetadata('VIDEO.WIDTH').value : '';
      size = umo.metadataList.getMetadata('VIDEO.FILESIZE') ? formatBytes(umo.metadataList.getMetadata('VIDEO.FILESIZE'), 2) : '';
      durationField = umo.metadataList.getMetadata('VIDEO.DURATION');
      duration = durationField && !isNaN(durationField.value) ? formatDuration(durationField.value) : '';
      break;
    case 'AUDIO':
      size = umo.metadataList.getMetadata('AUDIO.FILESIZE') ? formatBytes(umo.metadataList.getMetadata('AUDIO.FILESIZE'), 2) : '';
      durationField = umo.metadataList.getMetadata('AUDIO.DURATION');
      duration = durationField && !isNaN(durationField.value) ? formatDuration(durationField.value) : '';
      break;
    default:
      size = origData && origData.sz ? formatBytes(origData.sz, 2) : '';
      break;
  }

  const metaFields = umo.tombstoneMetadataList.all.map((tombstoneItem, i) =>
    <MetadataViewItem
      key={`${tombstoneItem.id}${i > 0 && `_${i}`}`}
      metadata={tombstoneItem}
      showValueOnly={false}
      parseList={session.get('parsedMetatags')}
      keywordDelim={session.get('keywordDelimiter')}
      dispatch={dispatch}
      customClass="list-item-tombstone"
    />
  );

  if (appConfig.listViewMetatags && Array.isArray(appConfig.listViewMetatags)) {
    let metaItem;
    appConfig.listViewMetatags.forEach((fieldName, i) => {
      metaItem = umo.metadataList.getMetadata(fieldName);
      if (metaItem && metaItem.value) {
        metaFields.push(<MetadataViewItem
          key={`${metaItem.id}${i > 0 && `_${i}`}`}
          metadata={metaItem}
          showValueOnly={false}
          parseList={session.get('parsedMetatags')}
          keywordDelim={session.get('keywordDelimiter')}
          dispatch={dispatch}
          customClass="list-item-tombstone"
        />);
      }
    });
  }
  return (
    <div className="row">
      <div className="col-sm-3">
        <li key={`fileName_${umo.id}`} className="meta-table__item list-item-tombstone">
          <div className="list-item-tombstone-name list-item-tombstone__base">
            {intl.formatMessage({ id: 'umoListItem.fileName' })}</div>
          <div className="meta-table__item-value">{ umo.name }</div>
        </li>
        <li key={`fileType_${umo.id}`} className="meta-table__item list-item-tombstone">
          <div className="list-item-tombstone-name list-item-tombstone__base">
            {intl.formatMessage({ id: 'umoListItem.type' })}</div>
          <div className="meta-table__item-value">{type}</div>
        </li>
        <li key={`fileSize_${umo.id}`} className="meta-table__item list-item-tombstone">
          <div className="list-item-tombstone-name list-item-tombstone__base">
            {intl.formatMessage({ id: 'umoListItem.size' })}</div>
          <div className="meta-table__item-value">{size}</div>
        </li>
        <li key={`fileHeight_${umo.id}`} className="meta-table__item list-item-tombstone">
          <div className="list-item-tombstone-name list-item-tombstone__base">
            {intl.formatMessage({ id: 'umoListItem.height' })}</div>
          <div className="meta-table__item-value">{height}</div>
        </li>
        <li key={`fileWidth_${umo.id}`} className="meta-table__item list-item-tombstone">
          <div className="list-item-tombstone-name list-item-tombstone__base">
            {intl.formatMessage({ id: 'umoListItem.width' })}</div>
          <div className="meta-table__item-value">{width}</div>
        </li>
        <li key={`fileDuration_${umo.id}`} className="meta-table__item list-item-tombstone">
          <div className="list-item-tombstone-name list-item-tombstone__base">
            {intl.formatMessage({ id: 'umoListItem.duration' })}</div>
          <div className="meta-table__item-value">{duration}</div>
        </li>
        <li key={`fileDate_${umo.id}`} className="meta-table__item list-item-tombstone">
          <div className="list-item-tombstone-name list-item-tombstone__base">
            {intl.formatMessage({ id: 'umoListItem.dateCreated' })}</div>
          <div className="meta-table__item-value">{date}</div>
        </li>
      </div>
      <div className="col-sm-8 list-item-tombstone-view">{metaFields}</div>
    </div>
  );
}
UMODataFields.propTypes = {
  umo: PropTypes.instanceOf(PictionJS.UMO).isRequired,
  session: PropTypes.instanceOf(Map),
  dispatch: PropTypes.func,
};
export default injectIntl(UMODataFields);



// WEBPACK FOOTER //
// ./src/js/components/UMOListItem/UMODataFields.jsx